// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vps-badge{padding:2px 4px;width:-webkit-max-content;width:-moz-max-content;width:max-content;border-radius:3px}.vps-badge-circle{min-width:8px;min-height:8px;border-radius:50%}.vps-badge-circle-empty,.vps-badge-circle:empty{width:8px;height:8px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
